var FeedbackExecutionService = /** @class */ (function () {
    /*@ngInject*/
    function FeedbackExecutionService(StorageService, genericServiceAjs) {
        this.StorageService = StorageService;
        this.genericServiceAjs = genericServiceAjs;
        this.urlConstants = {
            SHOW_RECRUITER_QUESTIONS: 'api/feedbackanswers/getrecruiterscreeningquestions',
            SAVE_RECRUITER_QUESTIONS: 'api/feedbackanswers/saverecruiterscreeningquestions',
            SAVE_JOB_MATCH_STATE: 'api/feedbackanswers/savejobmatchstate',
            GET_USER_LIST: 'api/feedbackanswers/getuserlist',
            GET_CANDIDATE_DETAILS: 'api/feedbackanswers/getcandidatedetails',
            CHECK_RECRUITER_SCREENING_STATUS: 'api/feedbackanswers/checkrecruiterscreeningstatus'
        };
    }
    FeedbackExecutionService.prototype.getCandidateDetails = function (jobMatchId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_CANDIDATE_DETAILS + '/' + jobMatchId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    FeedbackExecutionService.prototype.getUserList = function (jobMatchId, companyId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.GET_USER_LIST + '/' + jobMatchId + '/' + companyId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    FeedbackExecutionService.prototype.getRecruiterQuestions = function (jobMatchId, userId, companyId, meetingScheduleId, loggedInUserId, successCallback, errorCallback) {
        var url = this.StorageService.get('baseurl') + this.urlConstants.SHOW_RECRUITER_QUESTIONS + '/' + jobMatchId + '/' + userId + '?companyId=' + companyId;
        url = !_.isNull(meetingScheduleId) ? url + '&meetingScheduleId=' + meetingScheduleId : url;
        if (!_.isNull(loggedInUserId)) {
            url = url + "&loggedInUserId=" + loggedInUserId;
        }
        this.genericServiceAjs.getObjects(url).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    FeedbackExecutionService.prototype.saveRecruiterQuestions = function (feedbackExecutionResult, jobMatchId, loggedInUserId, successCallback, errorCallback) {
        var url = "api/feedbackanswers/saverecruiterscreeningquestions/" + jobMatchId;
        if (!_.isNull(loggedInUserId)) {
            url = url + "?loggedInUserId=" + loggedInUserId;
        }
        this.genericServiceAjs.addObject(url, feedbackExecutionResult).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    FeedbackExecutionService.prototype.saveJobMatchState = function (listOfjobdetails, statusOfSave, questionType, successCallback, errorCallback) {
        this.genericServiceAjs.addObject("api/feedbackanswers/savejobmatchstate/" + statusOfSave, listOfjobdetails).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    FeedbackExecutionService.prototype.checkRecruiterScreeningStatus = function (jobMatchId, userId, companyId, successCallback, errorCallback) {
        this.genericServiceAjs.getObjects(this.StorageService.get('baseurl') + this.urlConstants.CHECK_RECRUITER_SCREENING_STATUS + '/' + jobMatchId + '/' + userId + '?companyId=' + companyId).then(function (data) {
            successCallback(data);
        }, function (error) {
            errorCallback(error);
        });
    };
    return FeedbackExecutionService;
}());
export { FeedbackExecutionService };
//# sourceMappingURL=feedbackExecutionService.js.map